import React from "react";

// Single Goal Card Component
const GoalCard = ({ title, current, target, percentage, color }) => {
    return (
        <div className="bg-white p-5 rounded-xl shadow  w-full ">
            <h3 className="text-sm font-semibold text-gray-800">{title}</h3>

            <div className="flex justify-between mt-2 text-[22px] text-gray-500">
                <span className="text-xs py-2">Current</span>
                <span className="text-xs py-2">Level {current}</span>
            </div>
            <div className="flex justify-between text-xs text-gray-500">
                <span className="text-xs py-2">Target</span>
                <span className="text-xs py-2">Level {target}</span>
            </div>

            <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                <div
                    className={`${color} h-2.5 rounded-full text-xs`}
                    style={{ width: `${percentage}%` }}
                ></div>
            </div>

            <p className="text-xs text-gray-500 mt-1">{percentage}% to Goal</p>
        </div>
    );
};

// Wrapper Component for multiple goal cards
export default function GoalCards({ goals }) {
    return (

        <>
            {goals.map((goal, i) => (
                <GoalCard key={i} {...goal} />
            ))}
        </>


    );
}
